import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["operation", "trackingsection", "trackingtarget", "data"],
  _excluded2 = ["operation", "trackingsection", "trackingtarget", "data"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { useEffect, useState } from 'react';
import { dataMaintainer } from '../../components/ConfigProvider/rn/context';
import { TRACKING_OPERATION } from '../../utils/tracking/constants';
import { addObserver, removeObserver } from '../../utils/rn/intersectionObserver';
var getTrackingData = function getTrackingData(trackingdata) {
  var componentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!trackingdata) {
    return {};
  }
  var _ref = trackingdata || {},
    bypassClickTracking = _ref.bypassClickTracking,
    trackingsection = _ref.trackingsection,
    trackingtarget = _ref.trackingtarget,
    trackingdataBasic = _ref.trackingdataBasic,
    trackingdataTarget = _ref.trackingdataTarget,
    _ref$trackingItemData = _ref.trackingItemData,
    trackingItemData = _ref$trackingItemData === void 0 ? function () {
      return {};
    } : _ref$trackingItemData;
  var impressionTrackingData = _objectSpread(_objectSpread({}, trackingdataBasic), trackingItemData === null || trackingItemData === void 0 ? void 0 : trackingItemData(componentData));
  if (trackingdataTarget) {
    impressionTrackingData.button_details = [trackingdataTarget];
  }
  return {
    trackingClick: !bypassClickTracking ? {
      trackingsection: trackingsection,
      trackingtarget: trackingtarget,
      data: _objectSpread(_objectSpread(_objectSpread({}, trackingdataBasic), trackingdataTarget), trackingItemData === null || trackingItemData === void 0 ? void 0 : trackingItemData(componentData))
    } : undefined,
    trackingImpression: {
      // 'data-trackingindex': trackingindex,
      trackingsection: trackingsection,
      trackingtarget: trackingtarget,
      trackingdata: JSON.stringify(impressionTrackingData)
    },
    trackingScroll: {
      trackingsection: trackingsection,
      trackingtarget: trackingtarget,
      data: _objectSpread(_objectSpread({}, trackingdataBasic), trackingItemData === null || trackingItemData === void 0 ? void 0 : trackingItemData(componentData))
    }
  };
};
function useTracker() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    listRef = _useState2[0],
    setListRef = _useState2[1];
  var passedRef = function passedRef(ele, index) {
    if (!ele) {
      return;
    }
    if (typeof index === 'number') {
      setListRef(function (current) {
        var newListRef = _toConsumableArray(current);
        newListRef[index] = ele;
        return newListRef;
      });
      return;
    }
    setListRef(function (current) {
      return [].concat(_toConsumableArray(current), [ele]);
    });
  };
  var click = function click(_ref2) {
    var _dataMaintainer$track;
    var _ref2$operation = _ref2.operation,
      operation = _ref2$operation === void 0 ? TRACKING_OPERATION.CLICK : _ref2$operation,
      trackingsection = _ref2.trackingsection,
      trackingtarget = _ref2.trackingtarget,
      data = _ref2.data,
      rest = _objectWithoutProperties(_ref2, _excluded);
    (_dataMaintainer$track = dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : _dataMaintainer$track.dispatchTrack(_objectSpread({
      operation: operation,
      section: trackingsection,
      target: trackingtarget,
      data: data
    }, rest));
  };
  var scroll = function scroll(_ref3) {
    var _dataMaintainer$track2;
    var _ref3$operation = _ref3.operation,
      operation = _ref3$operation === void 0 ? TRACKING_OPERATION.Scroll : _ref3$operation,
      trackingsection = _ref3.trackingsection,
      trackingtarget = _ref3.trackingtarget,
      data = _ref3.data,
      rest = _objectWithoutProperties(_ref3, _excluded2);
    (_dataMaintainer$track2 = dataMaintainer.tracker) === null || _dataMaintainer$track2 === void 0 ? void 0 : _dataMaintainer$track2.dispatchTrack(_objectSpread({
      operation: operation,
      section: trackingsection,
      target: trackingtarget,
      data: data
    }, rest));
  };
  var impressionAddObserver = function impressionAddObserver(index) {
    // 在需要手动调用时使用
    if (typeof index === 'number') {
      // 有ref
      if (listRef[index]) {
        addObserver(listRef[index]);
      }
    } else {
      addObserver(listRef);
    }
  };
  var impressionRemoveObserver = function impressionRemoveObserver() {
    // 在需要手动调用时使用
    removeObserver(listRef);
  };
  useEffect(function () {
    listRef.length && setTimeout(function () {
      impressionAddObserver();
    });
    return function () {
      impressionRemoveObserver();
    };
  }, [listRef]);
  return {
    listRef: listRef,
    passedRef: passedRef,
    tracker: {
      click: click,
      scroll: scroll,
      impression: {
        addObserver: impressionAddObserver,
        removeObserver: impressionRemoveObserver
      }
    }
  };
}
export function useTracking(props) {
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    trackingImpressionProps = _useState4[0],
    setTrackingImpressionProps = _useState4[1];
  var _useTracker = useTracker(),
    tracker = _useTracker.tracker,
    passedRef = _useTracker.passedRef;
  var trackingData = props.trackingData,
    componentData = props.componentData;
  var _getTrackingData = getTrackingData(trackingData, componentData),
    trackingClick = _getTrackingData.trackingClick,
    trackingImpression = _getTrackingData.trackingImpression;
  useEffect(function () {
    var random = Math.random() + ''; // TODO 随机数生成

    trackingImpression && dataMaintainer.addTrackerMap(random, trackingImpression);
    trackingImpression && setTrackingImpressionProps({
      ref: passedRef,
      dataSet: {
        trackingkey: random
      }
    });
    return function () {
      tracker.impression.removeObserver();
      trackingImpression && dataMaintainer.deleteTrackerMap(random);
    };
  }, []);
  return {
    tracker: tracker,
    trackingClick: trackingClick,
    trackingImpression: trackingImpression,
    trackingImpressionProps: trackingImpressionProps
  };
}
export function useComponentTracking(props) {
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    result = _useState6[0],
    setResult = _useState6[1];
  var _useTracker2 = useTracker(),
    tracker = _useTracker2.tracker,
    passedRef = _useTracker2.passedRef;
  var componentTrackingData = props.componentTrackingData,
    componentData = props.componentData;
  useEffect(function () {
    var trackingkeys = [];
    componentTrackingData && Object.keys(componentTrackingData).forEach(function (key) {
      var random = Math.random() + ''; // TODO 随机数生成

      var _getTrackingData2 = getTrackingData(componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData[key], componentData),
        trackingClick = _getTrackingData2.trackingClick,
        trackingImpression = _getTrackingData2.trackingImpression,
        trackingScroll = _getTrackingData2.trackingScroll; // @ts-ignore

      trackingImpression && dataMaintainer.addTrackerMap(random, trackingImpression) && trackingkeys.push(random);
      setResult(function (old) {
        return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, key, {
          trackingClick: trackingClick,
          trackingScroll: trackingScroll,
          trackingImpression: trackingImpression,
          trackingImpressionProps: trackingImpression ? {
            ref: passedRef,
            dataSet: {
              trackingkey: random
            }
          } : {}
        }));
      });
    });
    return function () {
      tracker.impression.removeObserver();
      trackingkeys.forEach(function (key) {
        dataMaintainer.deleteTrackerMap(key);
      });
    };
  }, []);
  return {
    tracker: tracker,
    result: result
  };
}